<template>
  <div id="demo-basic-card">

    <vs-alert color="danger" title="Requested Question Not Found" :active.sync="test_not_found">
        <span>Test record with id: {{ $route.params.testId }} not found. </span>
        <span>
            <span>Check </span><router-link :to="{name:'tests'}" class="text-inherit underline">All Tests</router-link>
        </span>
    </vs-alert>

    <div id="module-data">
        <div id="editTestLoadingDiv" class="vs-con-loading__container">
            <vx-card title="Edit test" class="mb-base">
                <form data-vv-scope="addTestForm">
                    <div class="vx-row mb-base">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                            Test name
                            <vs-input v-validate="'required'" name="name" ref="name" class="w-full" label="" v-model="test_data.name" />
                            <span class="text-danger text-sm" v-show="errors.has('addTestForm.name')">{{ errors.first('addTestForm.name') }}</span>
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-2">
                            Test Language
                            <ul class="demo-alignment">
                                <li class="mt-3">
                                    <vs-radio @change="searchQuestions()" v-model="test_data.lang" vs-value="da">Danish</vs-radio>
                                </li>
                                <li class="mt-3">
                                    <vs-radio @change="searchQuestions()" v-model="test_data.lang" vs-value="en">English</vs-radio>
                                </li>
                            </ul>
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-2">
                            Test Type
                            <ul class="demo-alignment">
                                <li class="mt-3">
                                    <vs-radio v-model="test_data.module_type" vs-value="teori">Teori</vs-radio>
                                </li>
                                <li class="mt-3">
                                    <vs-radio v-model="test_data.module_type" vs-value="lession">Lession</vs-radio>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="vx-row mb-base">
                        <div class="vx-col sm:w-full mb-2">
                           <VueFileAgent
                            ref="vueFileAgendsdt"
                            :theme="'list'"
                            :multiple="false"
                            :deletable="true"
                            :meta="true"
                            :compact="true"
                            :accept="'image/*'"
                            :maxSize="'5MB'"
                            :helpText="'Choose a test image'"
                            :errorText="{
                              type: 'Invalid file type. Only image Allowed',
                              size: 'Files should not exceed 5MB in size',
                            }"
                            @select="filesSelected($event)"
                            @beforedelete="onBeforeDelete($event)"
                            @delete="fileDeleted($event)"
                            v-model="image"
                          ></VueFileAgent>
                        </div>
                    </div>

                    <div class="vx-row mb-base">
                        <div class="vx-col sm:w-4/12 w-full mb-2">
                            Test Duration
                            <vs-input v-validate="'integer'" name="duration" ref="duration" class="w-full" label="" v-model="test_data.duration" />
                            <span class="text-danger text-sm" v-show="errors.has('addTestForm.duration')">{{ errors.first('addTestForm.duration') }}</span>
                        </div>
                        <div class="vx-col sm:w-4/12 w-full mb-2">
                            Number of questions
                            <vs-input v-validate="'required|integer'" name="question_count" ref="question_count" class="w-full" label="" v-model="test_data.question_count" />
                            <span class="text-danger text-sm" v-show="errors.has('addTestForm.question_count')">{{ errors.first('addTestForm.question_count') }}</span>
                        </div>
                        <div class="vx-col sm:w-4/12 w-full mb-2">
                            Questions Type
                            <ul class="demo-alignment">
                                <li class="mt-3">
                                    <vs-radio v-model="test_data.test_type" vs-value="random">Random</vs-radio>
                                </li>
                                <li class="mt-3">
                                    <vs-radio v-model="test_data.test_type" vs-value="manual">Custom</vs-radio>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="vx-row mb-6" v-if="test_data.test_type == 'manual'">
                        <div class="vx-col w-full">
                            <span>Question categories</span>
                            <treeselect v-model="selectedcategories" :multiple="true" :options="question_categories_options" @input="catCanged()" />
                        </div>
                    </div>

                    <div class="vx-row mx-1 mb-base" v-if="test_data.test_type == 'manual'">
                        <div id="viewQuestionsLoadingDiv" class="vs-con-loading__container">
                            <div class="vx-col w-full mb-4">
                                Questions - {{selected.length}} selected of {{ test_data.question_count }}
                                <vs-table 
                                    max-items="20"
                                    @change-page="handleChangePage"
                                    @sort="handleSort"
                                    :data="questionsData">

                                    <template slot="thead">
                                        <vs-th>Id</vs-th>
                                        <vs-th>Image</vs-th>
                                        <vs-th sort-key="situation">Situation</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                            <vs-td :data="data[indextr].id">
                                                <vs-checkbox :vs-value="data[indextr].id" :value="data[indextr]" v-model="selected"></vs-checkbox>
                                            </vs-td>
                                            <vs-td :data="data[indextr].picture">
                                                <img width="100" :src="data[indextr].picture" alt="content-img">
                                            </vs-td>
                                            <vs-td :data="data[indextr].situation">
                                                {{data[indextr].situation}}
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>

                                <div class="vx-row mt-base">
                                    <div class="vx-col w-full mb-2">
                                        <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-full"  align="right">
                          <vs-button @click="validateCreateTest()" class="mr-3 mb-2">Edit Test</vs-button>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default{
    data() {
        return {
            selectedcategories : [],
            categories : [],
            test_data: {
                module_type : "teori",
                name : null,
                lang : "da",
                test_type : "random",
                duration : null,
                question_count : null,
            },
            test_not_found: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            modules_values : [],
            modules_options : [],
            otherModuleType_ : null,
            testName : null,
            selected:[],
            key : null, 
            active : null,
            search : null,
            totalPage: 1,
            currentPage: 1,
            image : [],
            fileRecordsForUpload : [],
        }
    },
    components: {
        VuePerfectScrollbar,
        Treeselect
    },
    watch: {
        currentPage(val) {
            this.pagiSearchQuestions()
        }
    },
    computed: {
        question_categories_options(){
            let categories = this.$store.state.questionManagement.categories
            let categoriesData = []

            categories.forEach(function(entry, key) {
                categoriesData.push({
                    id : entry.id,
                    title : entry.name,
                    label : entry.name,
                })
            });

            return categoriesData
        },
        questionsData() {
            return this.$store.state.questionManagement.questions
        },
    },
    methods: {
        async catCanged(){
            this.selected = []
            if(this.test_data.test_type == "manual"){
                var self = this
                this.$vs.loading({
                    container: '#viewQuestionsLoadingDiv',
                    scale: 0.6
                })

                let data = { 
                    lang : this.test_data.lang, 
                    categories : this.selectedcategories,
                }

                await this.$store.dispatch("questionManagement/getAllQuestions", data)
                    .then(res => { 
                        this.totalPage = res.data.last_page
                        this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                    })
                    .catch(err => { 
                        this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                    })
                }

        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        onBeforeDelete: function (fileRecord) {
            // this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
            // queued file, not yet uploaded. Just remove from the arrays
              this.fileRecordsForUpload.splice(i, 1);
              var k = this.image.indexOf(fileRecord);
              if (k !== -1) this.image.splice(k, 1);
            } else {
              this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            }
        },
        fileDeleted: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(fileRecord);
            // var i = this.fileRecordsForUpload.indexOf(fileRecord);
            // if (i !== -1) {
            //     this.fileRecordsForUpload.splice(i, 1);
            // } else {
            //     this.deleteUploadedFile(fileRecord);
            // }
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        handleSelected(tr) {
            console.log(this.selected)
        },
        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchQuestions()
            }, 2000);   
        },
        handleChangePage(page) {
            // this.searchUser()
        },
        handleSort(key, active) {
            if(key){
                this.key = key
                this.active = active
                this.searchQuestions()
            }
        },
        async searchQuestions() {
            this.selected = []
            if(this.test_data.test_type == "manual"){
                var self = this
                this.$vs.loading({
                    container: '#viewQuestionsLoadingDiv',
                    scale: 0.6
                })

                let data = { 
                    lang : this.test_data.lang, 
                    categories : this.selectedcategories,
                }

                await this.$store.dispatch("questionManagement/getAllQuestions", data)
                    .then(res => { 
                        this.totalPage = res.data.last_page
                        this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                    })
                    .catch(err => { 
                        this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                    })
                }
        },
        async pagiSearchQuestions() {
            if(this.test_data.test_type == "manual"){
                var self = this
                this.$vs.loading({
                    container: '#viewQuestionsLoadingDiv',
                    scale: 0.6
                })

                let data = { 
                    lang : this.test_data.lang, 
                    page : this.currentPage,
                    categories : this.selectedcategories,
                }

                await this.$store.dispatch("questionManagement/getAllQuestions", data)
                    .then(res => { 
                        this.totalPage = res.data.last_page
                        this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                    })
                    .catch(err => { 
                        this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                    })
                }
        },
        getAllQuestions() {
            let data = { 
                lang : this.test_data.lang, 
            }

            this.$store.dispatch("questionManagement/getAllQuestions", data)
                .then(res => { 
                    this.totalPage = res.data.last_page
                })
                .catch(err => { 
                })
        },
        redirectToAllPackages() {
            this.$router.push("/tests").catch(() => {})
        },
        validateCreateTest() {
            this.$validator.validateAll('addTestForm').then(result => {
                if (result){
                    if(this.test_data.test_type == "manual"){
                        if(this.test_data.question_count == this.selected.length) this.createTest();
                        else{
                            this.$vs.notify({
                              time:4000,
                              title:'Error',
                              text: "Selected questions count not match.",
                              color:'warning',
                              iconPack: 'feather',
                              icon:'icon-alert-circle'
                            });
                        }
                    }
                    else this.createTest();
                }
            })
        },
        createTest() {
            var self = this

            this.$vs.loading({
                container: '#editTestLoadingDiv',
                scale: 0.6
            })

            let data = new FormData();
            if(this.image.length) data.append('picture', this.image[0].file); 
            if(this.test_data.duration) data.append('duration', this.test_data.duration); 

            data.append('test_id', this.test_data.id); 
            data.append('name', this.test_data.name); 
            data.append('lang', this.test_data.lang); 
            data.append('test_type', this.test_data.test_type); 
            data.append('question_count', this.test_data.question_count); 
            data.append('module_type', this.test_data.module_type); 

            if(this.test_data.test_type == "manual"){
                for (var i = 0; i < this.selected.length; i++) {
                  data.append('questions[]', this.selected[i]);
                }
            }

            this.$store.dispatch("questionManagement/updateTest", data)
            .then(res => { 
                this.$vs.loading.close('#editTestLoadingDiv > .con-vs-loading')

                this.$vs.notify({
                  time:4000,
                  title:'Success',
                  text: 'Test successfully updated.',
                  color:'success',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'
                });
            })
            .catch(err => {
                this.$vs.loading.close('#editTestLoadingDiv > .con-vs-loading')

                // if(err.status && err.status == 422){
                //     Object.keys(err.data).forEach(function(key) {
                //         self.errors.add({
                //             field: key,
                //             msg: err.data[key][0],
                //         });
                //     });
                // }
            })
        },
    },
    async mounted(){
        this.$vs.loading({
            container: '#editTestLoadingDiv',
            scale: 0.6
        })

        await this.$store.dispatch("questionManagement/viewCategoryWithoutPaginate", {avoid_paginate : "true"})

        const testId = this.$route.params.testId
        this.$store.dispatch("questionManagement/viewTest", testId)
            .then(res => { 
                this.test_data = res.data 
                this.test_data.module_type = res.data.module_type == "lession" ? "lession" : "teori";

                if(res.data.test_type == "manual"){
                    this.selected = res.data.questions
                }
                
                this.$vs.loading.close('#editTestLoadingDiv > .con-vs-loading')
            })
            .catch(err => {
                this.test_not_found = true
                this.$vs.loading.close('#editTestLoadingDiv > .con-vs-loading')
            })

    },
    created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

        this.getAllQuestions()
    },

}
</script>

